/**
 * 本地历史记录管理
 * 使用localStorage存储用户的处理历史
 */

const HISTORY_KEY = 'banana_processing_history'
const MAX_HISTORY_ITEMS = 50 // 最多保存50条记录

/**
 * 历史记录项结构
 * {
 *   id: string,
 *   timestamp: number,
 *   operation: string,
 *   originalImages: Array<{name: string, size: number}>,
 *   resultImages: Array<string>,
 *   success: boolean
 * }
 */

/**
 * 获取所有历史记录
 * @returns {Array} 历史记录数组
 */
export function getHistory () {
  try {
    const history = localStorage.getItem(HISTORY_KEY)
    return history ? JSON.parse(history) : []
  } catch (error) {
    console.error('读取历史记录失败:', error)
    return []
  }
}

/**
 * 添加新的历史记录
 * @param {Object} record 历史记录项
 */
export function addHistoryRecord (record) {
  try {
    const history = getHistory()

    // 创建新记录
    const newRecord = {
      id: generateId(),
      timestamp: Date.now(),
      ...record
    }

    // 添加到历史记录开头
    history.unshift(newRecord)

    // 限制最大数量
    if (history.length > MAX_HISTORY_ITEMS) {
      history.splice(MAX_HISTORY_ITEMS)
    }

    // 保存到localStorage
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history))

    console.log('历史记录已保存:', newRecord)
    return newRecord
  } catch (error) {
    console.error('保存历史记录失败:', error)
  }
}

/**
 * 删除指定历史记录
 * @param {string} id 记录ID
 */
export function deleteHistoryRecord (id) {
  try {
    const history = getHistory()
    const filtered = history.filter(item => item.id !== id)
    localStorage.setItem(HISTORY_KEY, JSON.stringify(filtered))
    console.log('历史记录已删除:', id)
  } catch (error) {
    console.error('删除历史记录失败:', error)
  }
}

/**
 * 清空所有历史记录
 */
export function clearHistory () {
  try {
    localStorage.removeItem(HISTORY_KEY)
    console.log('历史记录已清空')
  } catch (error) {
    console.error('清空历史记录失败:', error)
  }
}

/**
 * 格式化时间显示
 * @param {number} timestamp 时间戳
 * @returns {string} 格式化的时间字符串
 */
export function formatTime (timestamp) {
  const date = new Date(timestamp)
  const now = new Date()
  const diff = now - date

  // 小于1分钟
  if (diff < 60000) {
    return '刚刚'
  }

  // 小于1小时
  if (diff < 3600000) {
    return `${Math.floor(diff / 60000)}分钟前`
  }

  // 小于1天
  if (diff < 86400000) {
    return `${Math.floor(diff / 3600000)}小时前`
  }

  // 小于7天
  if (diff < 604800000) {
    return `${Math.floor(diff / 86400000)}天前`
  }

  // 超过7天显示具体日期
  return date.toLocaleDateString('zh-CN', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * 生成唯一ID
 * @returns {string} 唯一ID
 */
function generateId () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2)
}

/**
 * 获取历史记录统计信息
 * @returns {Object} 统计信息
 */
export function getHistoryStats () {
  const history = getHistory()
  return {
    total: history.length,
    successful: history.filter(item => item.success).length,
    failed: history.filter(item => !item.success).length,
    mostRecentTime: history.length > 0 ? history[0].timestamp : null
  }
}
